import PropTypes from "prop-types";

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.node).isRequired
};

export default propTypes;
